// import { chains } from '@/constants/chains'
import { getTokenPairs, getAddress } from '@meterio/sumer-js'
import * as Sumer from '@meterio/sumer-js'
import { getAllLane, getIsShouldEnterTimelock, getQuoteSend } from '../../api'
import BigNumber from 'bignumber.js'
import { getSupportNetwork, StayNetworkId } from '../../constants'
import { Options } from '@layerzerolabs/lz-v2-utilities'
import { zeroPadValue, ethers } from 'ethers'

const namespaced = true

const state = {
  currentFromChain: {
    symbol: '',
  },
  currentToChain: {},
  fromChains: [],
  toChains: [],
  currentFromTokens: [],
  currentToTokens: [],
  currentFromToken: {
    symbol: '',
  },
  currentToToken: {},

  maxTokenBalance: 0,

  bridgeFee: {
    nativeFee: 0,
    lzTokenFee: 0
  },

  loading: false,

  errorInfo: '',
}

const getters = {}

const mutations = {
  setCurrentFromChain(state, currentFromChain) {
    state.currentFromChain = currentFromChain
  },
  setCurrentToChain(state, currentToChain) {
    state.currentToChain = currentToChain
  },
  setFromChains(state, fromChains) {
    state.fromChains = fromChains
  },
  setToChains(state, toChains) {
    state.toChains = toChains
  },
  setCurrentToken(state, currentFromToken) {
    if (!currentFromToken) {
      state.currentFromToken = {}
      state.currentToToken = {}
      return
    }
    state.currentFromToken = currentFromToken
    const currentToToken = state.currentToTokens.find((item) => item.symbol === currentFromToken.symbol)
    state.currentToToken = currentToToken
  },
  setCurrentFromTokens(state, currentFromTokens) {
    state.currentFromTokens = currentFromTokens
  },
  setCurrentToTokens(state, currentToTokens) {
    state.currentToTokens = currentToTokens
  },
  setMaxTokenBalance(state, maxTokenBalance) {
    state.maxTokenBalance = maxTokenBalance
  },

  setBridgeFee(state, bridgeFee) {
    state.bridgeFee = bridgeFee
  },
  setLoading(state, loading) {
    state.loading = loading
  },

  setErrorInfo(state, info) {
    state.errorInfo = info
  },

  clearData(state) {
    state.currentFromChain = {
      symbol: '',
    }
    state.currentToChain = {}
    state.fromChains = []
    state.toChains = []
    state.currentFromTokens = []
    state.currentToTokens = []
    state.currentFromToken = {
      symbol: '',
    }
    state.currentToToken = {}
  
    state.maxTokenBalance = 0
  
    state.bridgeFee = {
      nativeFee: 0,
      lzTokenFee: 0
    }
  
    state.loading = false
  
    state.errorInfo = ''
  }
}

const actions = {
  async initChain({ rootState, state, commit, dispatch }) {
    commit('clearData')
    const { sumer, currentNetwork } = rootState.wallet

    if (!currentNetwork) {
      console.log('none of currentNetwork')
      return
    }

    // console.log('token pairs', getTokenPairs(sumer._network.name))
    const chains = getSupportNetwork()
      .filter((net) => !!net.isTestnet === !!currentNetwork.isTestnet && (net.oftBridge2))
      .map((s) => {
        if (s.networkId === StayNetworkId) {
          return {
            ...s,
            tokens: [{
              address: '0xe85411C030fB32A9D8b14Bbbc6CB19417391F711',
              name: 'suBTC',
              symbol: 'suBTC',
              decimals: 18,
            }]
          }
        }
        const tokens = getTokenPairs(s.nameInCompoundjs)
          .filter((t) => t.underlySym.includes('su'))
          .map((t) => {
            const address = getAddress(s.nameInCompoundjs, t.underlySym)
            return {
              address,
              name: t.underlySym,
              symbol: t.underlySym,
              decimals: t.underlyDecimal,
            }
          })
        // const SumerAddr = getAddress(s.nameInCompoundjs, 'SUMER')
        // tokens.push({
        //   address: SumerAddr,
        //   name: 'SUMER',
        //   symbol: 'SUMER',
        //   decimals: 18,
        // })
        return {
          ...s,
          tokens,
        }
      })

    /**
     * { [chainId]: { srcTokens: string[]; dstTokens: string[] } }
     */
    const formatAllLane = {}
    if (currentNetwork.oftBridge2) {
      const allLane = await getAllLane(sumer, { oftAddress: currentNetwork.oftBridge2.proxyAddr })
      // console.log('allLane', allLane)
      if (allLane.length) {
        for (const lane of allLane) {
          const srcChainId = Number(lane.srcEid)
          const srcToken = lane.srcToken.toLowerCase()
          const dstToken = lane.dstToken.toLowerCase()
          if (formatAllLane[srcChainId]) {
            formatAllLane[srcChainId].srcTokens.push(srcToken)
            formatAllLane[srcChainId].dstTokens.push(dstToken)
          } else {
            formatAllLane[srcChainId] = { srcTokens: [srcToken], dstTokens: [dstToken] }
          }
        }
      }
    }

    const currentFromChain = chains.find(c => c.networkId === currentNetwork.networkId)
    const otherChains = chains.filter(c => c.networkId !== currentFromChain?.networkId)

    if (!currentFromChain) {
      console.log('unsupport current from chain')
      // console.log('chainschains', getSupportNetwork()
      //   .filter((net) => net.oftBridge2))
      commit('setFromChains', getSupportNetwork()
        .filter((net) => net.oftBridge2))
      commit('setErrorInfo', 'Unsupport network')
      return
    }

    commit('setCurrentFromChain', currentFromChain)

    const toChains = []

    if (otherChains.length) {
      for (const c of otherChains) {
        const fromTokens = currentFromChain.tokens
        const toTokens = c.tokens
        // console.log({ fromTokens, toTokens })
        const isSupportOft = currentFromChain.oftBridge2 && c.oftBridge2
        // const isSupportCCIP = currentFromChain.ccipBridge && c.ccipBridge
        // console.log({ isSupportOft, isSupportCCIP })
        const currentFromTokens = []
        const currentToTokens = []
        for (const f of fromTokens) {
          for (const t of toTokens) {
            if (f.symbol === t.symbol) {
              // 是否支持oft
              if (isSupportOft) {
                const srcTokens = formatAllLane[c.oftBridge2.eid]?.srcTokens || []
                const dstTokens = formatAllLane[c.oftBridge2.eid]?.dstTokens || []
                // console.log('isSupportOft', { srcTokens, dstTokens })
                if (dstTokens.includes(f.address.toLowerCase()) && srcTokens.includes(t.address.toLowerCase())) {
                  currentFromTokens.push(f)
                  currentToTokens.push(t)
                }
              }
              break
            }
          }
        }

        if (currentFromTokens.length) {
          toChains.push({ ...c, tokens: currentFromTokens })
        }
      }
    }

    commit('setFromChains', otherChains)

    if (!toChains.length) {
      console.log('no destination chains')
      commit('setErrorInfo', 'Stay tuned')
      return
    }

    const currentToChain = toChains[0]
    commit('setCurrentToChain', currentToChain)
    commit('setToChains', toChains.splice(1))

    dispatch('updateCurrentTokens')
  },
  async updateCurrentToChain({ rootState, state, commit, dispatch }, newCurrentToChain) {
    const { toChains, currentToChain } = state
    const tempToChains = toChains.filter((c) => c.networkId !== newCurrentToChain.networkId)

    commit('setToChains', [ ...tempToChains, currentToChain ])
    commit('setCurrentToChain', newCurrentToChain)
    dispatch('updateCurrentTokens')
  },
  async updateCurrentTokens({ rootState, state, commit, dispatch }) {
    // const { sumer } = rootState.wallet
    const { currentToChain } = state

    const tokens = currentToChain.tokens
    commit('setCurrentFromTokens', tokens)
    dispatch('updateCurrentToken', { currentToken: tokens[0] })
  },
  async updateCurrentToken({ rootState, commit, dispatch }, { currentToken }) {
    commit('setCurrentToken', currentToken)

    dispatch('getTokenBalance')
  },
  async getTokenBalance({ rootState, state, commit }) {
    const { currentFromToken } = state
    const { web3Provider, account } = rootState.wallet
    if (!currentFromToken.symbol || !account) {
      return
    }

    try {
      const contract = new ethers.Contract(currentFromToken.address, Sumer.abi.CErc20, web3Provider)
      const b = await contract.balanceOf(account)
      commit('setMaxTokenBalance', new BigNumber(String(b)).div(`1e${currentFromToken.decimals}`).toFixed(6, BigNumber.ROUND_DOWN))
    } catch (e) {
      console.log('get token balance err', e)
    }
  },
  async transfer({ rootState, state, commit, dispatch }, { amount }) {
    try {
      commit('setLoading', true)

      const { sumer, account } = rootState.wallet
      const { currentFromChain, currentFromToken, currentToChain, bridgeFee } = state

      await dispatch(
        'tx/send',
        {
          symbol: currentFromToken.symbol,
          tokenAddress: currentFromToken.address,
          fee: bridgeFee,
          toAddress: account,
          currentToChain: currentToChain,
          amount: new BigNumber(amount).times(1e18).toFixed(0),
        },
        { root: true },
      )
    } catch (e) {
      commit('setLoading', false)
    } finally {
      commit('setLoading', false)
    }
  },
  async getBridgeFee({ rootState, state, commit }, { amount }) {
    if (!amount || isNaN(Number(amount))) {
      return
    }
    try {
      const { sumer, account, currentNetwork } = rootState.wallet
      
      if (!sumer || !account || !currentNetwork.oftBridge2) {
        return
      }
      const { proxyAddr } = currentNetwork.oftBridge2
      const { currentFromChain, currentFromToken, currentToChain } = state
      const { GAS_LIMIT, MSG_VALUE } = currentToChain.oftBridge2

      const decimalsAmount = new BigNumber(amount).times(1e18).toFixed(0)
      console.log('decimalsAmount', decimalsAmount)

      const params = [
        currentFromToken.address,
        decimalsAmount,
      ]
      
      const shouldEnterTimelock = await getIsShouldEnterTimelock(sumer, {
        oftAddress: proxyAddr,
        params
      })

      const _options = Options.newOptions().addExecutorLzReceiveOption(
        shouldEnterTimelock ? GAS_LIMIT.Max : GAS_LIMIT.Min,
        MSG_VALUE
      );
    
      const sendParam = {
        dstEid: currentToChain.oftBridge2.eid,
        to: zeroPadValue(account, 32),
        token: currentFromToken.address,
        amountLD: decimalsAmount,
        minAmountLD: decimalsAmount,
        extraOptions: _options.toHex(),
        composeMsg: "0x",
        oftCmd: "0x",
      };
      const fee = await getQuoteSend(sumer, { oftAddress: proxyAddr, sendParam })
      console.log('bridge fee', fee)

      commit('setBridgeFee', fee)

      commit('setErrorInfo', '')
    } catch (e) {
      console.log('get bridge fee', e)
      commit('setErrorInfo', 'Cross-network transfers are temporarily unavailable. We appreciate your patience while we work to restore service.')
      commit('setBridgeFee', {
        nativeFee: 0,
        lzTokenFee: 0
      })
    }
  },
}

export const suTokenBridge = {
  namespaced,
  state,
  getters,
  mutations,
  actions,
}
